// Mirrors the JWT access token into IndexedDB so service-worker.js — which,
// unlike a page, has no access to localStorage — can make an authenticated
// request (declining a call) while the app is fully closed. Keep this in
// sync with the DB/store/key names read in public/service-worker.js.
const DB_NAME = "beramour-auth";
const DB_VERSION = 1;
const STORE_NAME = "tokens";
const ACCESS_TOKEN_KEY = "access_token";

const openDb = () =>
  new Promise((resolve, reject) => {
    if (!("indexedDB" in window)) {
      reject(new Error("IndexedDB not supported"));
      return;
    }
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

export async function cacheAccessTokenForServiceWorker(token) {
  if (!token) return;
  try {
    const db = await openDb();
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      tx.objectStore(STORE_NAME).put(token, ACCESS_TOKEN_KEY);
      tx.oncomplete = resolve;
      tx.onerror = () => reject(tx.error);
    });
    db.close();
  } catch (err) {
    console.warn("[TokenCache] Failed to cache access token:", err);
  }
}

export async function clearCachedAccessTokenForServiceWorker() {
  try {
    const db = await openDb();
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      tx.objectStore(STORE_NAME).delete(ACCESS_TOKEN_KEY);
      tx.oncomplete = resolve;
      tx.onerror = () => reject(tx.error);
    });
    db.close();
  } catch (err) {
    console.warn("[TokenCache] Failed to clear cached access token:", err);
  }
}
